$.fn.loadMorePosts = function() {
  let self = this
  var pageNumber = 0;
  var post_type = self.data('post_type');
  var posts_per_page = self.data('posts_per_page');
  var taxonomy = self.data('taxonomy');
  var term_id = self.data('term-id');
  var result_container_selector = self.prev('.js-load-more-posts-target');

  self.click(function() {
    pageNumber++;
    var str = '&pageNumber=' + pageNumber + '&action=more_post_ajax';
    if(post_type != null){
      str += '&post_type=' + post_type;
    }
    if(taxonomy != null && term_id != null){
      str += '&taxonomy=' + taxonomy + '&term_id=' + term_id;
    }
    if(post_type != null){
      str += '&posts_per_page=' + posts_per_page;
    }
    self.addClass('loading');
    $.ajax({
      url: '/wp/wp-admin/admin-ajax.php',
      dataType: "html",
      data: str, // form data
      type:"POST", // POST
      success:function(data){
        result_container_selector.append(data);
        if(data.indexOf('<span class="ajax-end"></span>') != -1){
          self.hide();
        }else{
          self.removeClass('loading');
        }
      }
    });
  });

  return function() {
    return self
  }()
}
